<template>
  <div id="contractDetails">
    <template v-if="!editMode">
      <div class="contract_info">
        <a-row class="title">
          <a-col :span="8">{{$t('deal.contract.addContract.companyName')}}</a-col>
          <a-col :span="8">{{$t('deal.contract.addContract.signTime')}}</a-col>
          <a-col :span="8">{{$t('deal.contract.addContract.startTime')}}</a-col>
        </a-row>
        <a-row class="content">
          <a-col :span="8">
            {{customerDO == null ? '' : customerDO.companyName}}
          </a-col>
          <a-col :span="8">
            {{contractVOLocal.signTime | dayjs}}
          </a-col>
          <a-col :span="8">
            {{contractVOLocal.startTime | dayjs}}-{{contractVOLocal.endTime | dayjs}}
          </a-col>
        </a-row>
        <a-row class="title">
          <a-col :span="8">{{$t('deal.contract.addContract.totalBrokerage')}}</a-col>
          <a-col :span="8">{{$t('deal.contract.addContract.serviceCycle')}}</a-col>
          <a-col :span="8">{{$t('deal.contract.addContract.serviceTimes')}}</a-col>
        </a-row>
        <a-row class="content">
          <a-col :span="8">
            {{contractVOLocal.totalBrokerage}}
            <pt-unit-select type="currency" disabled v-model="contractVOLocal.totalBrokerageUnit" :edit-mode="false"></pt-unit-select>
          </a-col>
          <a-col :span="8">
            {{serviceCycleOptions.find(e=>{return e.wordKey == contractVOLocal.serviceCycle}).wordValue}}
          </a-col>
          <a-col :span="8">
            {{contractVOLocal.serviceTimes}}
          </a-col>
        </a-row>
        <a-row class="title">
          <a-col>
            {{$t('deal.contract.addContract.content')}}
          </a-col>
        </a-row>
        <a-row class="content">
          <a-col>
            {{contractVOLocal.content}}
          </a-col>
        </a-row>
        <a-row v-if="contractVOLocal.fileDOList">
          <div class="title">
            {{$t('deal.contract.addContract.files')}}
          </div>
          <a-divider style="margin:0;"></a-divider>
          <div class="fileDiv">
            <div v-if="contractVOLocal.fileDOList && contractVOLocal.fileDOList.length > 0">
              <div v-for="(item,index) in contractVOLocal.fileDOList" :key="index" class="fileItem">
                <pt-icon type="icon-fujian2" class="fileIcon"></pt-icon>
                <div class="fileName">{{item.fileName}}</div>
                <div style="display: flex;align-items: center;">
                  <div @click="previewFile(item)"  v-if="$util.matchPreviewType(item.fileName)">
                    <pt-icon class="previewIcon" type="icon-yulancopy" :title="$t('baseVO.preview')"></pt-icon>
                  </div>
                  <div @click="downloadFile(item)" style="margin-left: 20px;">
                    <pt-icon class="downloadIcon" type="icon-xiazai" :title="$t('baseVO.download')"></pt-icon>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="noFileClass">
              {{$t('baseVO.empty')}}
            </div>
          </div>
        </a-row>
      </div>
    </template>
    <template v-else>
      <div>
        <addContract :contractVO="contractVO" ref="addContractRef" @saveContractSuccess="saveContractSuccess"></addContract>
      </div>
    </template>
  </div>
</template>

<script>
  import customerApi from '@/api/mine/customer'
  import contractApi from '@/api/mine/contract'
  import addContract from './addContract'
  import ownerApi from '@/api/database/owner'
  import { getDatadictChildsByPath } from '@/api/sys/datadict'

  export default {
    name: 'contractDetails',
    components:{
      addContract
    },
    props: {
      dealId:{
        type:String,
        default: null
      },
      contractVO:{
        type:Object,
        default:null
      },
      editMode:{
        type:Boolean,
        default:false
      }
    },
    data() {
      return {
        customerDO: null,
        contractVOLocal: {},
        serviceCycleOptions:[],
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      previewFile(file){
        this.$util.previewFile(file.id)
      },
      downloadFile(file){
        this.$util.dowLoadFile(file.id,file.fileName,this);
      },
      init(){
        this.initServiceCycleOptions()
        let this_ = this
        if(this.dealId == null && this.contractVO != null){
          this.contractVOLocal = JSON.parse(JSON.stringify(this.contractVO))
          let id = this.contractVO.customerId
          if(this.contractVO.customerType == 1){
            this.initCustomerOptions(id)
          }else{
            this.initOwner(id)
          }
        }else{
          contractApi.selectByDealId(this.dealId).then(res=>{
            if(res.code == 1){
              this_.contractVOLocal = res.data
              let id = this_.contractVOLocal.customerId
              if(this_.contractVOLocal.customerType == 1){
                this_.initCustomerOptions(id)
              }else{
                this_.initOwner(id)
              }
            }
          })
        }
      },
      initServiceCycleOptions(){
        let this_ = this
        getDatadictChildsByPath('system.business_key.contract.serviceCycle').then(res=>{
          this_.serviceCycleOptions = res.data
        })
      },
      initOwner(id){
        let p = new Promise((resolve,reject)=> {
          ownerApi.selectOne(id).then(res => {
            if (res.code == 1) {
              this.customerDO = res.data
              resolve()
            } else {
              reject()
            }
          })
        })
        return p
      },
      initCustomerOptions(id){
        // if(this.contractVO){
        //   let id = this.contractVO.customerId
          let p = new Promise((resolve,reject)=>{
            customerApi.selectOne(id).then(res=>{
              if(res.code == 1){
                this.customerDO = res.data
                resolve()
              }else{
                reject()
              }
            })
          })
          return p
        // }
      },
      saveContract(){
        this.$refs.addContractRef.saveContract()
      },
      saveContractSuccess(){
        this.$emit('saveContractSuccess')
      },
    },
    watch:{
      contractVO(){
        this.init()
      }
    }
  }
</script>

<style scoped lang="less">
  #contractDetails{
    .contract_info{
      padding: 20px;
      .title{
        font-size: 12px;
        color: #999999;
      }
      .content{
        margin-bottom: 10px;
        font-size: 12px;
        color: #333333;
      }
      .fileDiv{
        padding: 0 10px;
        background: rgba(248,249,251,0.62);
        border-radius: 0 0 4px 4px;
      }
      .fileItem{
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px 0;
        border-bottom: 1px solid #E7E7E7;
        .fileIcon{
          font-size: 18px;
        }
        .fileName{
          flex:1;
          font-size: 12px;
          color: #333333;
          margin: 0 10px;
        }
        .delIcon{
          font-size: 20px;
          cursor: pointer;
        }
      }
      .fileItem:last-child{
        border-bottom: 0px;
      }
      .noFileClass{
        padding: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        color: #999999;
      }
    }
  }
</style>